import config from "@/config"
import http from "@/utils/request"


export default {
    get: {
        url: `${config.API_URL}/api/app/shop/`,
        name: "根据店铺ID获取店铺信息",
        get: async function (params) {
            return await http.get(this.url + params);
        }
    },
    getVcVodes: {
        url: `${config.API_URL}/api/app/common-lookup/shop-vCCodes`,
        name: "获取VcCode列表",
        get: async function (params) {
            return await http.get(this.url, params);
        }
    },
    getShopList: {
        url: `${config.API_URL}/api/app/common-lookup/user-auth-shops`,
        name: "获取用户店铺列表",
        get: async function (params) {
            return await http.get(this.url, params);
        }
    },
    getShopPageList: {
        url: `${config.API_URL}/api/app/shop`,
        name: "获取店铺分页数据列表",
        get: async function (params) {
            return await http.get(this.url, params);
        }
    },
    updateSalesStatistics: {
        url: `${config.API_URL}/api/app/shop/vc-sales-statistics`,
        name: "VC销量统计报告获取开关",
        post: async function (params) {
            return await http.post(this.url, params);
        }
    },
    updateVcInventoryStatistics: {
        url: `${config.API_URL}/api/app/shop/vc-inventory-statistics`,
        name: "VC库存统计报告获取开关",
        post: async function (params) {
            return await http.post(this.url, params);
        }
    },
    updateVcInvoiceStatistics: {
        url: `${config.API_URL}/api/app/shop/is-invoice`,
        name: "VC发票获取开关",
        post: async function (params) {
            return await http.post(this.url, params);
        }
    },
    updateVcAds: {
        url: `${config.API_URL}/api/app/shop/is-ads-report`,
        name: "VC广告数据获取开关",
        post: async function (params) {
            return await http.post(this.url, params);
        }
    },

    //插件
    plugin: {
        getShopPluginTaskList: {
            url: `${config.API_URL}/api/app/shop-plugin-task/by-shop-id`,
            name: "获取店铺分页数据列表",
            get: async function (params) {
                return await http.get(this.url, params);
            }
        },
        enableAllPluginTask: {
            url: `${config.API_URL}/api/app/shop-plugin-task/enable-all-task`,
            name: "启用所有插件任务",
            post: async function (params) {
                return await http.post(this.url, params);
            }
        },
    },
    pluginExecLog: {
        getPageList: {
            url: `${config.API_URL}/api/app/plugin-task-exec-log/page-list`,
            name: "获取执行记录",
            get: async function (params) {
                return await http.get(this.url, params);
            }
        },
    }
}
